import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
import IconCircleUnchecked from '../icon/IconCircleUnchecked';
import IconCircleChecked from '../icon/IconCircleChecked';
import IconCircleDisabled from '../icon/IconCircleDisabled';
import IconSquareChecked from '../icon/IconSquareChecked';
import IconSquareUnchecked from '../icon/IconSquareUnchecked';
import IconSquareDisabled from '../icon/IconSquareDisabled';
import { CheckboxGroupContext } from './group';
import { IconStatus } from './type';
import { useMergeProps } from './hooks';

var getDefaultIcon = function getDefaultIcon(shape, status) {
  var defaultIcons = {
    circle: {
      normal: /*#__PURE__*/React.createElement(IconCircleUnchecked, null),
      active: /*#__PURE__*/React.createElement(IconCircleChecked, null),
      disabled: /*#__PURE__*/React.createElement(IconCircleDisabled, null),
      activeDisabled: /*#__PURE__*/React.createElement(IconCircleChecked, null)
    },
    square: {
      normal: /*#__PURE__*/React.createElement(IconSquareUnchecked, null),
      active: /*#__PURE__*/React.createElement(IconSquareChecked, null),
      disabled: /*#__PURE__*/React.createElement(IconSquareDisabled, null),
      activeDisabled: /*#__PURE__*/React.createElement(IconSquareChecked, null)
    },
    justify: {
      normal: /*#__PURE__*/React.createElement(IconCircleUnchecked, null),
      active: /*#__PURE__*/React.createElement(IconCircleChecked, null),
      disabled: /*#__PURE__*/React.createElement(IconCircleDisabled, null),
      activeDisabled: /*#__PURE__*/React.createElement(IconCircleChecked, null)
    }
  };
  return defaultIcons[shape][status];
};

export var Checkbox = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useMergeProps = useMergeProps(props, CheckboxGroupContext),
      _useMergeProps$style = _useMergeProps.style,
      style = _useMergeProps$style === void 0 ? {} : _useMergeProps$style,
      _useMergeProps$classN = _useMergeProps.className,
      className = _useMergeProps$classN === void 0 ? '' : _useMergeProps$classN,
      _useMergeProps$childr = _useMergeProps.children,
      children = _useMergeProps$childr === void 0 ? null : _useMergeProps$childr,
      _useMergeProps$label = _useMergeProps.label,
      label = _useMergeProps$label === void 0 ? '' : _useMergeProps$label,
      _useMergeProps$layout = _useMergeProps.layout,
      layout = _useMergeProps$layout === void 0 ? 'inline' : _useMergeProps$layout,
      value = _useMergeProps.value,
      _useMergeProps$defaul = _useMergeProps.defaultCheck,
      defaultCheck = _useMergeProps$defaul === void 0 ? false : _useMergeProps$defaul,
      _useMergeProps$disabl = _useMergeProps.disabled,
      disabled = _useMergeProps$disabl === void 0 ? false : _useMergeProps$disabl,
      _useMergeProps$shape = _useMergeProps.shape,
      shape = _useMergeProps$shape === void 0 ? 'circle' : _useMergeProps$shape,
      icons = _useMergeProps.icons,
      _useMergeProps$isRadi = _useMergeProps.isRadio,
      isRadio = _useMergeProps$isRadi === void 0 ? false : _useMergeProps$isRadi,
      propsChecked = _useMergeProps.checked,
      onChange = _useMergeProps.onChange;

  var _useState = useState(propsChecked === void 0 ? defaultCheck : propsChecked),
      checked = _useState[0],
      setChecked = _useState[1];

  var _useState2 = useState(isRadio ? 'radio' : 'checkbox'),
      componentName = _useState2[0];

  var domRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      dom: domRef.current
    };
  });
  useEffect(function () {
    if (propsChecked !== void 0) setChecked(Boolean(propsChecked));
  }, [propsChecked]);
  /**
   * 获得图标样式
   */

  var getStatus = function getStatus() {
    if (checked) {
      if (disabled) return IconStatus.ACTIVE_DISABLED;
      return IconStatus.ACTIVE;
    } else {
      if (disabled) return IconStatus.DISABLED;
      return IconStatus.NORMAL;
    }
  };
  /**
   * 计算展示的icon
   */


  var renderIcon = function renderIcon() {
    var Icon;
    var iconKey = getStatus();

    if (icons && icons[iconKey] !== void 0) {
      Icon = icons[iconKey];
    } else if (icons === null) {
      Icon = null;
    } else {
      Icon = layout === 'justify' ? getDefaultIcon('justify', iconKey) : getDefaultIcon(shape, iconKey);
    }

    return Icon ? /*#__PURE__*/React.createElement("div", {
      className: cls(componentName + "-icon", {
        disabled: disabled,
        checked: checked
      })
    }, Icon) : null;
  };
  /**
   * 处理点击事件
   */


  var onClick = function onClick(e) {
    if (disabled) return; // Radio组件不支持点击取消选中

    if (isRadio && checked) return;
    onChange && onChange(!checked, value, e);

    if (propsChecked === void 0) {
      setChecked(!checked);
    }
  };

  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement("div", {
      ref: domRef,
      style: style,
      className: cls(className, prefixCls + "-" + componentName, "shape-" + shape, {
        disabled: disabled
      }, layout),
      onClick: onClick
    }, layout !== 'justify' && renderIcon(), /*#__PURE__*/React.createElement("div", {
      className: componentName + "-text"
    }, children || label || value), layout === 'justify' && renderIcon());
  });
});